import React, { useEffect, useState, Fragment } from "react";
import axios from "axios";
import { Edit, Search, Trash2, Download, PlusCircle } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { 
  Container, 
  Row, 
  Col, 
  Form, 
  InputGroup, 
  Button, 
  Table, 
  Spinner, 
  Modal, 
  Alert 
} from "react-bootstrap";
import * as XLSX from "xlsx";
import { getInventoryItems } from "../../../../../redux/inventory";
import { getProcedures } from "../../../../../Data/Customer/api";
import LabEntry from "./LabEntry";
import { getLabItems } from "../../../../../redux/lab";
import LabCategory from "./LabCategory";

const LabManagement = (props) => {
  const itemsList = useSelector((state) => state.itemsList);
  const lab = useSelector((state) => state.lab);
  const [editData, setEditData] = useState("");
  const dispatch = useDispatch();
  const { labData } = lab;
  const { itemsData, supplierData, purchaseData } = itemsList;
  const auth = useSelector((state) => state.authentication);
  const { userData } = auth;
  
  const [itemName, setItemName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [alertCount, setAlertCount] = useState("");
  const [formData, setFormData] = useState("");
  const [modal, setModal] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [procedureDataDownload, setProcedureDataDownload] = useState("");
  const [procedures, setProcedures] = useState("");
  
  const toggle = () => setModal(!modal);

  const getLabItemsHandler = () => {
    dispatch(
      getLabItems({
        token: userData.token,
        branch: userData.branch,
      })
    );
  };

  useEffect(() => {
    if (userData.branch && userData.token) getLabItemsHandler();
  }, [userData.branch, userData.token]);

  useEffect(() => {
    if (labData && labData.length) {
      setProcedureDataDownload(() =>
        labData.filter(
          (item, index, self) =>
            index ===
            self.findIndex(
              (t) => t.testname === item.testname && t.method === item.method
            )
        )
      );
    }
    console.log(labData);
  }, [labData]);

  const exportToExcel = (data) => {
    const transformedData = data.map((item, index) => {
      const { _id, ...rest } = item;
      return { "Sl.No": index + 1, ...rest };
    });

    const ws = XLSX.utils.json_to_sheet(transformedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "my-file.xlsx");
  };

  const editCategoryHandler = (Data, toggle) => {
    setFormData(Data);
    setEditData(Data);
    toggle();
  };

  const deleteHandler = (item) => {
    const categoryName = prompt(
      "Please enter the category name to confirm delete"
    );
    if (
      categoryName &&
      categoryName.toLocaleLowerCase() === item.categoryName.toLocaleLowerCase()
    ) {
      axios
        .delete(`${process.env.REACT_APP_CRI_API}delete-lab`, {
          params: { id: item._id, branch: userData.branch },
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        })
        .then((res) => {
          if (res) {
            getLabItemsHandler();
          }
        })
        .catch((err) => {
          if (
            (err.response.data &&
              err.response.data.err &&
              err.response.data.err.name === "TokenExpiredError") ||
            err.response.data.message === "Unauthorized"
          ) {
            navigate("/");
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("srchData");
            sessionStorage.removeItem("prescriptionHistory");
            sessionStorage.removeItem("rights");
            navigate("/cri-crm");
            return err;
          }
        });
    } else if (categoryName) {
      alert("Batch not matching");
    }
  };

  return (
    <Container fluid className="px-4 py-3 bg-light min-vh-100">
      
      {/* Top Context Control Banner */}
      <Row className="align-items-center g-3 mb-4 bg-white p-3 rounded-3 shadow-sm">
        <Col md={4} lg={3}>
          <Button
            variant="primary"
            className="w-100 d-inline-flex align-items-center justify-content-center gap-2 py-2 fw-semibold shadow-sm"
            onClick={() => {
              setEditData("");
              toggle();
            }}
          >
            <PlusCircle size={18} /> Add New Test
          </Button>
        </Col>
        
        <Col md={5} lg={6}>
          <InputGroup className="shadow-xs">
            <InputGroup.Text className="bg-white border-end-0 text-muted">
              <Search size={18} />
            </InputGroup.Text>
            <Form.Control
              type="text"
              className="border-start-0 ps-1 py-2"
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="Search Test Name or Category..."
            />
          </InputGroup>
        </Col>
        
        <Col md={3} lg={3} className="text-md-end">
          <Button 
            variant="outline-secondary" 
            className="w-100 w-md-auto d-inline-flex align-items-center justify-content-center gap-2 py-2 px-4 shadow-sm bg-white"
            onClick={() => exportToExcel(procedureDataDownload)}
          >
            <Download size={16} /> Export Dataset
          </Button>
        </Col>
      </Row>

      {/* Main Dynamic View Matrix Panel */}
      <Row>
        <Col md={12}>
          {!labData && (
            <div className="text-center py-5 bg-white rounded-3 shadow-sm">
              <Spinner animation="border" variant="primary" role="status" className="mb-2" />
              <div className="text-muted small">Loading system records matrix...</div>
            </div>
          )}
          
          {labData && labData.length > 0 && (
            <div className="table-responsive rounded-3 border border-light-subtle shadow-sm bg-white">
              <Table responsive striped hover className="mb-0 align-middle">
                <thead className="table-dark text-nowrap small text-uppercase font-monospace border-bottom">
                  <tr>
                    <th className="py-3 px-3">Category</th>
                    <th className="py-3" style={{ width: "20%" }}>Test Name</th>
                    <th className="py-3">Sub Test</th>
                    <th className="py-3">Specimen</th>
                    <th className="py-3">Reference Range</th>
                    <th className="py-3">Units</th>
                    <th className="py-3">Method</th>
                    <th className="py-3">Notes</th>
                    <th className="py-3 text-center" style={{ width: "80px" }}>Edit</th>
                    <th className="py-3 text-center" style={{ width: "80px" }}>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {labData
                    .filter(
                      (item) =>
                        !searchInput ||
                        item.categoryName
                          .toLowerCase()
                          .includes(searchInput.toLowerCase()) ||
                        (item.notes && item.notes
                          .toLowerCase()
                          .includes(searchInput.toLowerCase()))
                    )
                    .map((categoryItem) => (
                      <Fragment key={categoryItem._id}>
                        {categoryItem.tests.map((test, testIndex) => (
                          <Fragment key={testIndex}>
                            {test.subTests.map((subTest, subTestIndex) => (
                              <tr key={subTestIndex} className="align-middle">
                                
                                {subTestIndex === 0 && (
                                  <td 
                                    rowSpan={test.subTests.length} 
                                    className="fw-bold text-secondary bg-light bg-opacity-25 border-end border-light-subtle p-3 align-top"
                                  >
                                    {categoryItem.categoryName}
                                  </td>
                                )}
                                
                                {subTestIndex === 0 && (
                                  <td 
                                    rowSpan={test.subTests.length}
                                    className="fw-medium text-dark bg-light bg-opacity-10 border-end border-light-subtle p-3 align-top"
                                  >
                                    {test.testName}
                                  </td>
                                )}
                                
                                <td className="p-2 fw-normal text-muted">{subTest.subTestName}</td>
                                <td className="p-2 text-capitalize small">{subTest.specimen}</td>
                                <td className="p-2 font-monospace small">{subTest.referenceRange}</td>
                                <td className="p-2 small">{subTest.units}</td>
                                <td className="p-2 text-uppercase small text-muted">{subTest.method}</td>
                                <td className="p-2 text-wrap small text-secondary" style={{ maxWidth: "200px" }}></td>
                                
                                <td className="p-2 text-center">
                                  <Button
                                    variant="link"
                                    className="p-1 d-inline-flex align-items-center link-success border-0 bg-transparent"
                                    onClick={() => editCategoryHandler(categoryItem, toggle)}
                                  >
                                    <Edit size={16} />
                                  </Button>
                                </td>
                                
                                <td className="p-2 text-center">
                                  <Button
                                    variant="link"
                                    className="p-1 d-inline-flex align-items-center link-danger border-0 bg-transparent"
                                    onClick={() => deleteHandler(categoryItem)}
                                  >
                                    <Trash2 size={16} />
                                  </Button>
                                </td>

                              </tr>
                            ))}
                          </Fragment>
                        ))}
                      </Fragment>
                    ))}
                </tbody>
              </Table>
            </div>
          )}
        </Col>
      </Row>

      {/* Lab Management Edit/Create Fullscreen Drawer Modal */}
      <Modal show={modal} onHide={toggle} fullscreen className="modal-fullscreen-sheet">
        <Modal.Header closeButton className="bg-dark text-white p-3">
          <Modal.Title className="fs-5 fw-bold font-monospace">
            {editData ? "Modify Lab Configurations Matrix" : "Register New Structural Test Procedure"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light p-4">
          <LabEntry
            formData={formData}
            setFormData={setFormData}
            getLabItemsHandler={getLabItemsHandler}
            toggle={toggle}
            editData={editData}
          />
        </Modal.Body>
        <Modal.Footer className="border-top p-2 bg-white">
          <Button variant="secondary" className="px-4" onClick={toggle}>
            Close Interface
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Global Async Operation Saving Modal Fallback Overlay */}
      <Modal show={showModal} backdrop="static" centered size="sm">
        <Modal.Body className="text-center p-4">
          <Spinner animation="border" variant="primary" style={{ width: "3rem", height: "3rem" }} className="mb-3" />
          <p className="mb-0 fw-bold font-monospace text-dark tracking-wide">Syncing Configurations...</p>
        </Modal.Body>
      </Modal>

    </Container>
  );
};

export default LabManagement;